
import dayjs from 'dayjs';

const parseMessage = (messages, value) => {
  const subString = messages.toString().replace("{item}", value);
  return subString;
};

const parseMessages = (messages, value, status) => {
  const subString = messages
    .toString()
    .replace("{item}", value)
    .replace("{status}", status);
  return subString;
};

const toPascalText = (text) => {
  if (text) {
    let space_checker = text.split(" ");
    const wordsCount = space_checker.length;

    let newText = "";
    if (wordsCount > 0) {
      space_checker.forEach((item) => {
        newText += `${getPascalText(item)} `;
      });
      return newText.trimEnd();
    }
    newText = getPascalText(text);
    return newText;
  }
};

const toNumeric = (value) => {
  return value.replace(/[^0-9]*$/g, "");
}

const getPascalText = (text) => {
  const textLength = text.length;
  const firstChar = text.substring(0, 1).toUpperCase();
  const remainderChars = text.substring(1, textLength);
  return firstChar + remainderChars;
};

const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

// Source https://stackoverflow.com/users/300011/ege-%c3%96zcan
const setDynamicSort = (property) => {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};

const blobTobase64 = (blob) => new Promise((resolve, reject)=> {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  reader.onload = ()=> resolve(reader.result);
  reader.onerror = () => reject(reader.error);
})

function base64ToBlob(base64DataURL) {
  const [meta, base64String] = base64DataURL.split(',');
  const mime = meta.match(/:(.*?);/)[1];

  const byteCharacters = atob(base64String); // Decode base64 to binary string
  const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) =>
    byteCharacters.charCodeAt(i)
  );
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], { type: mime }); // This is your binary file object
}

const generateUUID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

//  Source: ID number validation
//  https://stackoverflow.com/questions/13344294/south-african-id-number-validate-and-get-age-and-gender
const isSAIDNumberValid = (idNumber) => {
  // assume everything is correct and if it later turns out not to be, just set this to false
  var correct = true;

  //Ref: http://www.sadev.co.za/content/what-south-african-id-number-made
  // SA ID Number have to be 13 digits, so check the length
  if (idNumber.length != 13 || !isNumber(idNumber)) {
    correct = false;
  }
  // get first 6 digits as a valid date
  var tempDate = new Date(
    idNumber.substring(0, 2),
    idNumber.substring(2, 4) - 1,
    idNumber.substring(4, 6)
  );

  var id_date = tempDate.getDate();
  var id_month = tempDate.getMonth();
  var id_year = tempDate.getFullYear();

  var fullDate = id_date + "-" + (id_month + 1) + "-" + id_year;

  if (
    !(
      tempDate.getYear() == idNumber.substring(0, 2) &&
      id_month == idNumber.substring(2, 4) - 1 &&
      id_date == idNumber.substring(4, 6)
    )
  ) {
    correct = false;
  }
  // This validates the unique date 29-02-2000
  if (
    idNumber.substring(0, 2) == "00" &&
    idNumber.substring(2, 4) == "02" &&
    idNumber.substring(4, 6) == "29"
  ) {
    correct = true;
  }
  // get the gender
  var genderCode = idNumber.substring(6, 10);
  var gender = parseInt(genderCode) < 5000 ? "Female" : "Male";

  // get country ID for citzenship
  var citzenship = parseInt(idNumber.substring(10, 11)) == 0 ? "Yes" : "No";

  // apply Luhn formula for check-digits
  var tempTotal = 0;
  var checkSum = 0;
  var multiplier = 1;
  for (var i = 0; i < 13; ++i) {
    tempTotal = parseInt(idNumber.charAt(i)) * multiplier;
    if (tempTotal > 9) {
      tempTotal =
        parseInt(tempTotal.toString().charAt(0)) +
        parseInt(tempTotal.toString().charAt(1));
    }
    checkSum = checkSum + tempTotal;
    multiplier = multiplier % 2 == 0 ? 1 : 2;
  }
  if (checkSum % 10 != 0) {
    correct = false;
  }

  return correct;
};

const isNumber = (value) => !isNaN(parseFloat(value)) && isFinite(value);

const isFinYearValid = (finYear) => {
  const finYearFormat = /(19|20)\d{2}\/\d{2}$/;
  if (!finYear) {
    return { results: false, message: "Financial Year is required" };
  }
  if (!finYearFormat.test(finYear)) {
    return { results: false, message: "Financial Year format is not valid" };
  }

  const sepIndex = finYear.indexOf("/");
  const startIndex = sepIndex - 2;
  const prevYear = finYear.toString().substr(startIndex, sepIndex - 2);
  const nextYear = finYear.toString().substr(sepIndex + 1, finYear.length);
  const fullPrevYear = `${finYear.toString().substr(0, sepIndex)}`;
  const fullNextYear = `${
    parseInt(finYear.toString().substr(0, sepIndex)) + 1
  }`;

  const startFinYear = `01/04/${fullPrevYear}`;
  const endFinYear = `31/03/${fullNextYear}`;

  if (nextYear == parseInt(prevYear) + 1) {
    return {
      results: true,
      message: "",
      startFinYear: startFinYear,
      endFinYear: endFinYear,
    };
  } else if (prevYear == 99 && nextYear == "00") {
    return {
      results: true,
      message: "",
      startFinYear: startFinYear,
      endFinYear: endFinYear,
    };
  }
  return {
    results: false,
    message: "Financial Year value is not within acceeptible range",
  };
};

const getNextFinancialYear = (activeFinYear) => {
  const sepIndex = activeFinYear.indexOf("/");
  const startIndex = sepIndex - 2;
  const prevYear = activeFinYear.toString().substr(startIndex, sepIndex - 2);
  const nextYear = activeFinYear
    .toString()
    .substr(sepIndex + 1, activeFinYear.length);
  const fullPrevYear = `${activeFinYear.toString().substr(0, sepIndex)}`;
  const fullNextYear = `${
    parseInt(activeFinYear.toString().substr(0, sepIndex)) + 1
  }`;

  const startFinYear = `01/04/${fullPrevYear}`
  const endFinYear = `31/03/${fullNextYear}`

  if ((nextYear == parseInt(prevYear) + 1)) {
    return {"results":true, "message": "", startFinYear: startFinYear, endFinYear: endFinYear};
  }
  else if (prevYear == 99 && (nextYear == '00')) {
    return {"results":true, "message": "", startFinYear: startFinYear, endFinYear: endFinYear};
  }
  return {"results":false, "message": "Financial Year value is not within acceeptible range"};
}

const getFinancialYearRangeData = (startYear) => {
  const today = dayjs();

  const currentFinYearStart =
    today.month() >= 3 ? today.year() : today.year() - 1;

  const isCurrentFY = startYear === currentFinYearStart;
    const start = dayjs(`${startYear}-04-01`).startOf("day");
    let end;

    if (isCurrentFY) {
    end = today.endOf("day");
  } else {
    end = dayjs(`${startYear + 1}-03-31`).endOf("day");
  }

  return {
    label: `${startYear}/${String(startYear + 1).slice(-2)}`,
    start: start,
    end,
    isCurrentFY
  };
};

const getLastFinancialYears = (count = 3) => {
  const today = dayjs();

  const currentYear = today.month() >= 3 ? today.year() : today.year() - 1;

  return Array.from({ length: count }, (_, i) =>
    getFinancialYearRangeData(currentYear - i),
  );
};

const getCurrentRepotYear = () => {
  const extendedFinacialYearMonths = ["January", "February", "March"];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.toLocaleString("default", { month: "long" });

  return extendedFinacialYearMonths.includes(currentMonth)
    ? currentYear - 1
    : currentYear;
};

const getInitialDate = () => {
  const reportYear = getCurrentRepotYear();

  const currentDate = new Date();
  return new Date(currentDate.setFullYear(reportYear));
};

// This is meant for capturing dates that were modified by Excel into float
const fromExcelNumDateToDate = (value) => {
  // This is for SA dates using formats like (DD-MM-YYYY or DD/MM/YYYY)
  const regex = /\b(\d{2})-(\d{2})-(\d{4})\b|\b(\d{4})\/(\d{2})\/(\d{2})\b/g;
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  };

  const matchedDate = value.toString().match(regex);

  let finalDate;
  if (matchedDate === null) {
    // UNIX start date January 1, 1970
    // Excel start date January 1, 1900
    // UNIX start - Excel date in days = 25569 days
    // Milliseconds in a single day (24*60*60) * 1000
    finalDate = new Date(
      (value - 25569) * (24 * 60 * 60) * 1000
    ).toLocaleDateString(options);

    return finalDate;
  }
  return matchedDate;
};

const dataToCSVFriendly = (data, year) => {
  const columns = Object.keys(data);
  let flatCSVData = [];

  columns?.forEach((column) => {
    let total = 0;
    const newData = data[column]?.reduce((result, subItem) => {
      const { group: key, value } = subItem;
      total = value; // Just return value, total no longer needed
      result[key] = Math.round(total, 0);
      return result;
    }, {});

    let _data = { key: column, Year: year, ...newData };

    flatCSVData.push(_data);
  });

  return flatCSVData;
};

const groupDataByType = (data, year, hasTotal = false) => {
  let groupedValues = [];
  groupedValues = data?.reduce((groups, item) => {
    let { type: key, value, group } = item;

    if (item && item.category) {
      group = item.category;
    } else if (group === undefined && !hasTotal) {
      group = key;
    } else if (group === undefined && hasTotal) {
      group = "Total";
    }

    if (groups[key]) {
      groups[key].push({ group: group, value: value });
    } else {
      groups[key] = [{ group: group, value: value }];
    }
    return groups;
  }, {});

  const flatCSVData = dataToCSVFriendly(groupedValues, year);

  return flatCSVData;
};

const partnerDataToCSV = (data, year) => {
  const columns = Object.keys(data);
  let flatCSVData = [];

  columns?.forEach((column) => {
    let total = 0;
    const newData = data[column]?.reduce((result, subItem) => {
      const { group: key, value } = subItem;
      total = value + total; // Just return value, total no longer needed
      result[key] = Math.round(total, 0);
      return result;
    }, {});

    let _data = { key: column, Year: year, ...newData };

    flatCSVData.push(_data);
  });

  return flatCSVData;
};

const groupPartnerData = (data, year) => {
  let groupedValues = [];
  groupedValues = data?.reduce((groups, item) => {
    let { type: key, value, group } = item;

    if (item && item.type) {
      group = "Total";
    } else if (group === undefined) {
      group = key;
    }

    if (groups[key]) {
      groups[key].push({ group: group, value: value });
    } else {
      groups[key] = [{ group: group, value: value }];
    }
    return groups;
  }, {});

  const flatCSVData = partnerDataToCSV(groupedValues, year);

  return flatCSVData;
};

const convertArrayDataToCSV = (data) => {
  const keys = Object.keys(data[0]);
  const rows = [];

  rows.push(keys.join(","));

  data.forEach((obj) => {
    const values = keys.map((key) => obj[key]);
    rows.push(values.join(","));
  });

  return rows.join("\n");
};

const calculateRetention = (data) => {
  var chartData = data;
  const retentionData = [];
  const mainData = [];
  chartData?.forEach((dataItem) => {
    if (dataItem.type === "Retention") {
      retentionData.push({
        year: dataItem.year,
        "Retention % (end of year)": dataItem.value,
      });
    } else if (dataItem.type === "Start") {
      mainData.push({
        type: "Total # of STARTING partners for the year (baseline)",
        year: dataItem.year,
        value: dataItem.value,
      });
    } else if (dataItem.type === "New") {
      mainData.push({
        year: dataItem.year,
        type: "Total # of NEW partners for the year (growth)",
        value: dataItem.value,
      });
    } else if (dataItem.type === "Volunteer Scientist Start Profiles") {
      mainData.push({
        year: dataItem.year,
        type: "Total # of STARTING volunteers for the year (baseline)",
        value: dataItem.value,
      });
    } else if (dataItem.type === "Volunteer Scientist New Profiles") {
      mainData.push({
        year: dataItem.year,
        type: "Total # of NEW volunteer for the year (growth)",
        value: dataItem.value,
      });
    }
  });

  return { mainData, retentionData };
};

const transposeGrowthData = (data) => {
 var sData = [...data].sort((a,b) => a.year - b.year);
  var result = [];
  var rData = [];
  var yr = data[0].year;
  var total =0;
  sData.forEach(d => {
    if (yr === d.year) {
      rData.push({
        "Year": d.year,
        "Start":  d.type === "Volunteer Scientist Start Profiles" ? d.value:0,
        "New": d.type === "Volunteer Scientist New Profiles"? d.value:0
      });
    } else {
       result.push({
        "Year": yr,
        "Volunteer Scientist Start Profiles": rData[0].Start,
        "Volunteer Scientist New Profiles": rData[1].New,
        "Total": rData[0].Start + rData[1].New
      });
      rData = [];
      rData.push({
        "Year": d.year,
        "Start":  d.type === "Volunteer Scientist Start Profiles" ? d.value:0,
        "New": d.type === "Volunteer Scientist New Profiles"? d.value:0
      })
       yr = d.year;
    }
  })
   total = rData[0].Start + rData[0].New;
   result.push({
        "Year": yr,
        "Volunteer Scientist Start Profiles": rData[0].Start,
        "Volunteer Scientist New Profiles": rData[1].New,
         "Total": rData[0].Start + rData[1].New
      });
  return result;
};


//! This should be deprecated since it's no longer being used
const calculateVolunteerRetention = ( data ) => {
  var chartData = data;
  const retentionData = [];
  const mainData = [];
  chartData?.forEach((dataItem) => {
      // if (dataItem.type === "Volunteer Scientist New Profiles") {
      //     retentionData.push({
      //         "year": dataItem.year,
      //         "Retention % (end of year)": dataItem.value
      //     });
      // } else 
      
      if (dataItem.type === "Volunteer Scientist Start Profiles") {
          mainData.push({
              "type": "Total # of STARTING volunteers for the year (baseline)",
              "year": dataItem.year,
              "value": dataItem.value
          });
      } else if (dataItem.type === "Volunteer Scientist New Profiles") {
          mainData.push(
              {
                  "year": dataItem.year,
                  "type": "Total # of NEW volunteer for the year (growth)",
                  "value": dataItem.value
              });
      }
  });

  return {mainData, retentionData};
}

const getCurrentFinancialYear = () => {
  const year = getCurrentRepotYear ();
  return getFinancialYearRange([year]);
}

const getFinancialYearRange = (years) => {
  const finYears = years.map((y) => {
    const nextYear = y + 1;
    const finYear = {
      id: y,
      shortValue: `${y}/${nextYear.toString().slice(-2)}`,
      value: `${y}/${nextYear}`
    }
    return finYear;
  });

  finYears.sort((a, b) => b.id - a.id);

  return finYears;
}

const getYearsWithReports = async (reportAPI, setFinancialYears, setReportYear, isLocation = false) => {
  try {
    const response = await reportAPI.getYearRange(isLocation);
    if (response && response.status === 200) {
      const { values } = response.data;
      const finYears = getFinancialYearRange(values);
      setFinancialYears(finYears);

      var maxFinYear = Math.max(...values);
      if (getCurrentRepotYear() !== maxFinYear) {
        setReportYear(maxFinYear);
      }
    }
  } catch (error) { }

}

const getCurrentDate = () => {
  return dayjs(Date())
}

const getEnvVariable = (key) => {
  return process.env.NODE_ENV === "development" ? process.env[key] : window._CONFIGS[key];
};

const createFrequencyCounter = (grams) => {
  const frequencyMap = {};
  grams.forEach((gram) => {
    frequencyMap[gram] = (frequencyMap[gram] || 0) + 1;
  });
  return frequencyMap;
};

const computeQgramSimilarity = (queryGrams, targetGrams) => {
  const queryCounter = createFrequencyCounter(queryGrams);
  const targetCounter = createFrequencyCounter(targetGrams);
  let commonGramsCount = 0;

  for (let gram in queryCounter) {
    if (targetCounter[gram]) {
      commonGramsCount += Math.min(queryCounter[gram], targetCounter[gram]);
    }
  }

  return commonGramsCount;
};

const generateQGrams = (text, q = 3) => {
  text = text.replace(/[^a-z0-9]/gi, "");
  text = `$${text.replace(/\s+/g, "$")}$`;
  const qgrams = [];
  for (let i = 0; i <= text.length - q; i++) {
    qgrams.push(text.slice(i, i + q));
  }
  return qgrams;
};

const findMatchingDocuments = (query, qgramInstit) => {
  const queryGrams = generateQGrams(query.toLowerCase());
  const results = [];
  const duplicates = [];

  queryGrams?.forEach((qGram) => {
    let foundItems = qgramInstit[qGram];
    foundItems?.forEach((doc) => {
      const docGrams = generateQGrams(doc.toLowerCase());
      const score = computeQgramSimilarity(queryGrams, docGrams);
      if (score > 0) {
        if (!duplicates.includes(doc)) {
          results.push({ query: query, document: doc, score: score });
          duplicates.push(doc);
        }
      }
    });
  });

  // Sort the results by score in descending order
  return results.sort((a, b) => b.score - a.score).slice(0, 10);
};

const findMatchingDocumentsOld = (query, documents, qgramInstit) => {
  const queryGrams = generateQGrams(query.toLowerCase());
  const results = [];
  const qgramList = [];
  const foundItems = qgramInstit[query];
  documents.forEach((doc) => {
    // const docGrams = generateQGrams(doc.display_name_clean.toLowerCase());
    const docGrams = generateQGrams(doc.name.toLowerCase());
    const score = computeQgramSimilarity(queryGrams, docGrams);
    qgramList.push({ name: doc.name, qgrams: docGrams });
    if (score > 0) {
      // Store document and its score
      results.push({ document: doc, score });
    }
  });

  // Sort the results by score in descending order
  return results.sort((a, b) => b.score - a.score);
};

const findLocation = (query, qGramList) => {
  // const parseFile = JSON.parse(locationList);
  // const parseFile = locationList;
  let matchingScores = findMatchingDocuments(query, qGramList);

  return matchingScores.slice(0, 10);
};

export const util = {
  getYearsWithReports,
  getCurrentRepotYear,
  getCurrentFinancialYear,
  getFinancialYearRange,
  getInitialDate,
  isEmpty,
  isSAIDNumberValid,
  blobTobase64,
  base64ToBlob,
  generateUUID,
  parseMessage,
  parseMessages,
  toNumeric,
  toPascalText,
  setDynamicSort,
  fromExcelNumDateToDate,
  convertArrayDataToCSV,
  groupDataByType,
  groupPartnerData,
  isFinYearValid,
  getNextFinancialYear,
  calculateRetention,
  findLocation,
  getCurrentDate,
  calculateVolunteerRetention,
  transposeGrowthData,
  getLastFinancialYears,
  getEnvVariable
};
